// SERVICE_AUDIENCE_COLORS_v1 (26.09.2026, Toby: „alle Dienstleistungen, die Frauen betreffen, … leichtes Rot, so
// pastellig … die Männer betreffen … pastellblau … sowohl für die Online-Buchung als auch in Shearly“; Variante A =
// zarter Ton + Streifen links; „Farbe“ zählt als Damen; Kinder und Weitere bleiben neutral).
//
// EINE Regel für Buchungsseite und Pro: dieselbe Zuordnung steht in static/booking.html (groupKeyFor + SVC_TINT,
// SERVICE_GROUPS_v1). Beide Stellen IMMER gemeinsam ändern, sonst färben Buchungsseite und Pro verschieden.
// Zugeordnet wird nach der KATEGORIE der Leistung (nicht nach dem Namen), Reihenfolge der Prüfung wie dort.
// Halbtransparente Töne -> passen in hell UND dunkel und auf jedem der 4 Farbschemata ohne Extra-Variablen.

export const svcGroupOf = (cat) => {
  const c = (cat || "").toLowerCase();
  if (/farb|colou?r|strähn|strahn|tönung|toenung|balayage|ombr|highlight|blondier|glossing/.test(c)) return "farbe";
  if (/kind|kids/.test(c)) return "kind";
  if (/herr|männ|maenn|\bmann/.test(c)) return "mann";
  if (/damen|frau/.test(c)) return "frau";
  return "weitere";
};

export const SVC_TINT = {
  frau: { bg: "rgba(240,149,149,0.14)", bgStrong: "rgba(240,149,149,0.24)", edge: "#F09595", dot: "#DC4C4C", label: "Damen" },
  mann: { bg: "rgba(133,183,235,0.16)", bgStrong: "rgba(133,183,235,0.28)", edge: "#85B7EB", dot: "#3B82F6", label: "Herren" },
};

// null = neutral (Kinder, Weitere)
export const svcTintOf = (cat) => {
  const g = svcGroupOf(cat);
  if (g === "frau" || g === "farbe") return SVC_TINT.frau;
  if (g === "mann") return SVC_TINT.mann;
  return null;
};
